import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import nUnit from '../media/Nex4.png'
import { useSelector } from 'react-redux'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

function Liquid({ nex }) {
  const [addNex, setAddNex] = useState(false)
  const [hide, setHide] = useState(false)

  const user = useSelector(state=> state.user.user)
  const nx = useSelector(state=> state.nex.nex)

  return (
    <LiquidContainer style={{position: 'relative'}}>
      <DoubleArrowIcon onClick={()=> setHide(prev=> !prev)} style={{transform: hide? 'rotate(0deg)': 'rotate(180deg)', right: hide? '10px': '2px'}}/>
      {!hide && <OperationsContainer active={addNex}>
        {user.prem && <span className='prem' style={{display: 'flex', flexDirection: 'row', alignItems: 'center', color: '#de2699', cursor: 'auto'}}><AllInclusiveIcon/></span>}
        {!user.prem && <span><InfoIcon onMouseEnter={()=> setAddNex(true)} onMouseLeave={()=> setAddNex(false)}/></span>}
        {addNex && !user.prem && <NexPopup nex={nx}>
          {nx !== 0 && <p style={{fontWeight: nx > 60?'bold': 'normal', display: 'flex', alignItems: 'center'}}><img src={nUnit} /> You currently have <span style={{color: '#de2699', paddingInline: '4px'}}>{nx}</span> Nexilum units </p>}
          <br/>

          {nx === 0 && <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}><img src={nUnit} /><WarningIcon style={{color: '#de2699'}}/>Insufficient Nexilum units!  </p>}
          
          {nx > 60 && <p>

                Let's keep the magic flowing! ✨
         </p>}
        </NexPopup>}
      </OperationsContainer>}
      
      {!hide && <GlassBar>
        <Nexilum nex={(nx < 60 && nx > 0)? nx: nx === 60? 60: nx > 60? 60: 0} prem={user?.prem}/>
      </GlassBar>}
    </LiquidContainer>
  )
}

export default Liquid

const ShadowAnimation = keyframes`
  0% {
    box-shadow: -1px 0px 27px 6px #de2699;
  }

  25% {
    box-shadow: -1px 0px 25px 8px #c72087;
    background-color: #c72087;
  }

  50% {
    box-shadow: -1px 0px 27px 12px #de2699;
    background-color: #de2699;
  }

  60% {
    box-shadow: -1px 0px 27px 7px #f83baf;
    background-color: #f83baf;
  }

  75% {
    box-shadow: -1px 0px 25px 5px #de2699;
    background-color: #de2699;
  }

  100% {
    box-shadow: -1px 0px 27px 6px #de2699;    
  }
`


const FadeEffect = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const LiquidContainer = styled.div`
    background-color: rgb(0, 0, 36);
    width: 4%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;

    > .MuiSvgIcon-root {
      position: absolute;
      top: 40px;
      color: lightgray;
      transform: rotate(180deg);
      font-size: larger;
      cursor: pointer;
      transition: color 0.3s ease-in-out;
      transition: transform 0.3s ease-in-out;

      &:hover {
        color: #de2699;
      }
    }
`

const GlassBar = styled.div`
  width: 10px;
  height: 80%;
  background-color: var(--ml-color);
  border-radius: 2px;
  display: flex;
  align-items: flex-end;
`


const Nexilum = styled.div`
  width: 10px;
  height: ${props=> props.prem? 100 : (props.nex/60)*100}%;
  background-color: #de2699;
  box-shadow: -1px 0px 27px 6px #de2699;
  animation: ${ShadowAnimation} 10s ease-in-out infinite;
  border-radius: 2px;
`


const premIcon = keyframes`
  0% {
    color: #de2699;
  }

  25% {
    color: pink;
  }

  50% {
    color: purple;
  }

  75% {
    color: palevioletred;
  }

  100% {
    color: #de2699;
  }
`


const OperationsContainer = styled.div`
  display: flex;
  padding: 2px 4px;
  border-radius: 3px;
  border: 1px solid black;
  margin-top: 10px;
  color: ${props=> props.active? '#de2699': 'rgba(255, 255, 255, 0.5)'};

  > span {
    position: relative;

    &:hover {
      color: #de2699;
    }
  }

  > .prem {
    animation: ${premIcon} 10s ease-in-out infinite;
  }
`


const NexPopup = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border: 1px solid #de2699;
  border-radius: 3px;
  color: white;
  background-color: var(--ml-color);
  /* width: 260px; */
  width: ${props=> props.nex > 60? 300: 260}px;
  height: fit-content;
  top: 40px;
  left: 10px;
  z-index: 10000;

  opacity: 0;
  animation: ${FadeEffect} 0.3s ease-in-out forwards;

  > p {
    font-size: 14px;
  }

  > p > img {
    width: 30px;
  }
`